export interface RegisterState {
  errorMessages: string[];
  registered: boolean;
}

export interface RegisterAction {
  type: string;
  [key: string]: unknown;
}

export const initialState = (): RegisterState => ({ errorMessages: [], registered: false });

export default function register(
  state: RegisterState = initialState(),
  action?: RegisterAction
): RegisterState {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case 'NOT_REGISTERED':
      return {
        ...state,
        registered: false,
        errorMessages: (action.errorMessages as string[]) ?? []
      };
    case 'REGISTERED':
      return { ...state, registered: true, errorMessages: [] };
    default:
      return state;
  }
}
